const modalReason = {
  actionCancel: 'Cancelar',
  adminLocked: 'Administrador bloqueado',
  constractTerminated: 'Restricción cancelada',
  temporarySuspended: 'Suspendido temporal',
  textAreaPlaceholder: 'Introduzca el motivo',
};

export default modalReason;
